<template>
  <!-- Start Brand Area -->
  <v-row>
    <v-col cols="12" class="text-center">
      <h2 class="heading-title">{{ title }}</h2>
      <p>{{ subtitle }}</p>
      <ul class="brand-style mt-15">
        <li v-for="(brand, i) in brandImages" :key="i">
          <a :href="brand.url">
            <img :src="brand.src" alt="Logo Images" />
          </a>
        </li>
      </ul>
    </v-col>
  </v-row>
  <!-- End Brand Area -->
</template>

<script>
  import {container} from "@/main";
  import {HomeService} from "@/pages/home/home.service";

  export default {
    async created() {
      this.homeService = container.get(HomeService);
      const brands = await this.homeService.getBrands();
      var parser = new DOMParser();

      // Usar parseFromString para convertir la cadena HTML en un documento HTML
      const doc = parser.parseFromString(brands.content.rendered, 'text/html');
      this.subtitle = doc.querySelector('p').textContent;
      this.title = brands.title.rendered;
      const images = doc.querySelectorAll('img');
      this.brandImages = [];
      for(const image of images) {
        this.brandImages.push({
          src: image.src,
          url: "javascript:void(0)"
        })
      }
    },
    data() {
      return {
        title: null,
        subtitle: null,
        brandImages: [
          {
            src: require("../../../assets/images/brand/brand-01.png"),
            url: "#",
          },
          {
            src: require("../../../assets/images/brand/brand-02.png"),
            url: "#",
          },
          {
            src: require("../../../assets/images/brand/brand-03.png"),
            url: "#",
          },
          {
            src: require("../../../assets/images/brand/brand-04.png"),
            url: "#",
          },
          {
            src: require("../../../assets/images/brand/brand-05.png"),
            url: "#",
          },
          {
            src: require("../../../assets/images/brand/brand-06.png"),
            url: "#",
          },
        ],
      };
    },
  };
</script>
